import React, { Component } from 'react';
//import { BrowserRouter } from 'react-router-dom'
import Builder from './Components/Builder/Builder';
//import {Breadcrumbs} from 'react-router-breadcrumbs';

class App extends Component {

  render() {
 		//console.log(this.props);
    return (
      <div>
          <Builder data={this.props} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js